module.exports = __webpack_public_path__ + "img/pngkit_truck-vector.a507063a.png";